<template>
  <div class="member-analysis">
    <div class="header-ctn">
      <div class="title-ctn">
        <span class="title">会员分析</span>
        <img src="~@/assets/questionTip.png" @click="showTooltip" />
      </div>
      <span class="header-right">近30天</span>
    </div>
    <div class="desc">统计时间内，各渠道新增会员概况分析。其中,"全部"不包含期初导入数据</div>
    <div class="hr" />
    <div class="btn-group">
      <span :class="source === -1 ? 'active' : ''" @click="switchSourceTpe(-1)">全部</span>
      <span :class="source === 2 ? 'active' : ''" @click="switchSourceTpe(2)">POS端</span>
      <span :class="source === 1 ? 'active' : ''" @click="switchSourceTpe(1)">管理端</span>
      <span :class="source === 7 ? 'active' : ''" @click="switchSourceTpe(7)">小智会员</span>
    </div>
    <div class="swiper-container card-panel-list">
      <div class="swiper-wrapper">
        <div :class="activeCard === 1 ? 'selected' : ''" class="card-panel swiper-slide" @click="switchChart(1)">
          <div class="content">
            <div class="title">新增会员数</div>
            <div class="num">{{ memberData.newMemberTotal }}</div>
          </div>
        </div>
        <div v-if="source === 7 || source === -1" :class="activeCard === 5 ? 'selected' : ''" class="card-panel swiper-slide" @click="switchChart(5)">
          <div class="content">
            <div class="title">绑定会员数</div>
            <div class="num">{{ memberData.bindMemberTotal }}</div>
          </div>
        </div>
        <div :class="activeCard === 2 ? 'selected' : ''" class="card-panel swiper-slide" @click="switchChart(2)">
          <div class="content">
            <div class="title">会员订单数</div>
            <div class="num">{{ memberData.orderTotal }}</div>
          </div>
        </div>
        <div :class="activeCard === 3 ? 'selected' : ''" class="card-panel swiper-slide" @click="switchChart(3)">
          <div class="content">
            <div class="title">会员销售额</div>
            <div class="num">¥{{ memberData.memberMoneyTotal }}</div>
          </div>
        </div>
        <div :class="activeCard === 4 ? 'selected' : ''" class="card-panel swiper-slide" @click="switchChart(4)">
          <div class="content">
            <div class="title">会员销售额占比</div>
            <div class="num">{{ memberData.rate }}%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="member-chart">
      <van-loading v-if="loading" type="spinner" />
      <template v-if="activeCard !== 4">
        <template v-if="chartData.data">
          <line-chart ref="chart" :chart-data="chartData" />
        </template>
        <template v-else>
          <div class="empty-ctn">
            <div class="empty-img">
              <img src="~@/assets/empty.png" />
            </div>
            <div class="no-text">暂无数据</div>
          </div>
        </template>
      </template>
      <template v-else>
        <circle-bar :rate="rate" :lengend-title="'会员销售额占比'" />
      </template>
    </div>
    <van-popup v-model="showTip" round position="bottom" :style="{ height: '40%' }">
      <div class="tip-container">
        <p class="tip"><span>新增会员数：</span>统计时间内，新增会员的数量</p>
        <p class="tip"><span>绑定会员数：</span>统计时间内，通过小智会员绑定会员卡的会员数量</p>
        <p class="tip"><span>会员订单数：</span>统计时间内，新增会员的订单数</p>
        <p class="tip"><span>会员销售额：</span>统计时间内，新增会员带来的销售额同pos端传入的订单【实收金额】合计，扣去已经退款的金额</p>
        <p class="tip"><span>会员销售额占比：</span>统计时间内，会员销售额在店铺销售额的占比</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import LineChart from './LineChart'
import CircleBar from './CircleBar'
import Swiper from 'swiper' //导入
import 'swiper/swiper-bundle.min.css'
import { getOrderDataStat } from '@/api/robot'
export default {
  components: {
    LineChart,
    CircleBar
  },
  props: {},
  data() {
    return {
      source: -1, //默认全部
      activeCard: 1, // 1-新增会员数 2-会员订单数 3-会员销售额 4-会员销售额占比 5-绑定订单数
      showTip: false,
      memberData: {
        allMoneyTotal: 0, // 所有销售额
        memberChart: null, // 新增会员图表
        memberMoneyTotal: 0, // 会员销售额
        moneyChart: null, // 会员销售额图表
        newMemberTotal: 0, // 新增会员总数
        orderChart: null, // 会员订单数图表
        orderTotal: 0, // 会员订单数
        rate: 0, // 会员销售额占比
        bindMemberTotal: 0, // 绑定会员数
        bindMemberChart: null // 绑定会员图表
      },
      chartData: {
        type: 'member',
        cardType: 1,
        data: null
      },
      loading: false
    }
  },
  computed: {
    rate() {
      return this.memberData.rate
    }
  },
  created() {
    this.getOrderDataStat(true)
  },
  mounted() {
    new Swiper('.card-panel-list', {
      loop: false,
      freeMode: true,
      // width: 100,
      on: {
        transitionEnd: function(swiper, event) {
          if (this.getTranslate() <= -270) {
            this.setTranslate(-270)
          }
        }
      }
    })
  },
  methods: {
    resizeChart() {
      if (this.$refs.chart && this.$refs.chart.chart) {
        this.$refs.chart.chart.resize()
      }
    },
    async getOrderDataStat(init = false) {
      try {
        this.loading = true
        const res = await getOrderDataStat({ source: this.source })
        this.memberData = res
        if (init) {
          this.chartData = {
            ...this.chartData,
            data: this.memberData.memberChart
          }
        }
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log('getOrderDataStat', e)
      }
    },
    switchSourceTpe(type) {
      if (this.source === type) return
      this.source = type
      if (this.source !== 7 && this.activeCard === 5 && this.source !== -1) {
        this.activeCard = 1
      }
      this.setChartData(true)
    },
    switchChart(type) {
      if (this.activeCard === type) return
      this.activeCard = type
      this.setChartData()
    },
    /**
     * @param {String} reload 是否重新请求数据
     */
    async setChartData(reload = false) {
      const source = this.source
      const cardType = this.activeCard
      if (reload) {
        this.chartData = {
          type: 'member',
          cardType,
          data: null
        }
        await this.getOrderDataStat(source)
      }
      let data = null
      if (cardType === 1) {
        data = this.memberData.memberChart
      } else if (cardType === 2) {
        data = this.memberData.orderChart
      } else if (cardType === 3) {
        data = this.memberData.moneyChart
      } else if (cardType === 5) {
        data = this.memberData.bindMemberChart
      }
      this.chartData = {
        type: 'member',
        cardType,
        data
      }
    },
    showTooltip() {
      this.showTip = true
    }
  }
}
</script>

<style lang="less" scoped>
.member-analysis {
  min-height: 548px;
  background: #ffffff;
  box-shadow: 0 0 12px 0 rgba(48, 48, 60, 0.08);
  border-radius: 4px;
  padding: 20px 14px 0 14px;
  .header-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-ctn {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
    }
    .header-right {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #999999;
    }
    img {
      width: 15px;
      height: 15px;
      padding-left: 6px;
      padding-right: 6px;
    }
  }
  .desc {
    font-family: PingFangSC-Regular;
    font-size: 11px;
    color: #999999;
    margin: 16px 0;
  }
  .hr {
    position: relative;
    border: none;
  }

  .hr:after {
    content: '';
    position: absolute;
    top: 0;
    background: #f3f3f3;
    width: 100%;
    height: 2px;
    transform: scaleY(0.5);
    transform-origin: 0 0;
  }
  .btn-group {
    padding: 16px 0;
    span {
      display: inline-block;
      box-sizing: border-box;
      width: 76px;
      height: 27px;
      line-height: 27px;
      background: #ffffff;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #333333;
      border: 1px solid #dedfde;
      border-radius: 2px;
      &:nth-child(2) {
        margin: 0 5px;
      }
      &:nth-child(3) {
        margin-right: 5px;
      }
      &.active {
        background: #5183f8;
        color: #ffffff;
      }
    }
  }
  .swiper-container {
    width: 100%;
  }
  .card-panel-list {
    display: flex;
    .card-panel {
      box-sizing: border-box;
      width: 95%;
      height: 50px;
      border: 1px solid #dedfde;
      border-radius: 3px;
      padding-top: 6px;
      padding-left: 6px;
      margin-right: 2px;
      // &:nth-child(3) {
      //   width: 26%;
      // }
      // &:last-child {
      //   width: 31%;
      //   margin-right: 0;
      // }
      &.selected {
        background: rgba(70, 117, 240, 0.1);
        border: 1px solid #4675f0;
      }
      .title {
        font-family: PingFangSC-Regular;
        font-size: 11px;
        color: #999999;
        margin-bottom: 4px;
      }
      .num {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333333;
      }
    }
    .swiper-slide {
      width: 90px !important;
      &:nth-last-of-type(1) {
        width: 110px !important;
      }
    }
  }
  .member-chart {
    margin-top: 16px;
  }
}
</style>
